import { render, staticRenderFns } from "./upsert-item.vue?vue&type=template&id=83f19c4a&scoped=true"
import script from "./upsert-item.vue?vue&type=script&lang=js"
export * from "./upsert-item.vue?vue&type=script&lang=js"
import style0 from "./upsert-item.vue?vue&type=style&index=0&id=83f19c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f19c4a",
  null
  
)

export default component.exports